import React from 'react';
import PropTypes from 'prop-types';
import AppsCard from './AppsCard';
import {AppsIcon} from '@web/assets/icons';
import {Button, Tooltip} from 'antd';

AddAppButton.propTypes = {
  onSelect: PropTypes.func,
  children: PropTypes.node,
};

function AddAppButton({onSelect, children, ...props}) {
  return <Tooltip
    placement={"bottomRight"}
    title={<AppsCard onSelect={onSelect} />}
  >
    <Button size="large" className="icon-btn" {...props}>{children}</Button>
  </Tooltip>
}

export default AddAppButton;
